import { baseSplitApiSubjects as api } from "./config/baseApiSubjects";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    searchSubjects: build.mutation<
      SearchSubjectsApiResponse,
      SearchSubjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/search`,
        method: "POST",
        body: queryArg.searchSubjectsParams,
        params: {
          pageNum: queryArg.pageNum,
          pageLen: queryArg.pageLen,
          scenario: queryArg.scenario,
          activeRole: queryArg.activeRole,
        },
      }),
    }),
    getSubject: build.query<GetSubjectApiResponse, GetSubjectApiArg>({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.id}`,
        params: { referenceDate: queryArg.referenceDate },
      }),
    }),
    deleteSubject: build.mutation<
      DeleteSubjectApiResponse,
      DeleteSubjectApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    insertSubject: build.mutation<
      InsertSubjectApiResponse,
      InsertSubjectApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects`,
        method: "POST",
        body: queryArg.subject,
      }),
    }),
    createSubjectAddress: build.mutation<
      CreateSubjectAddressApiResponse,
      CreateSubjectAddressApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/addresses`,
        method: "POST",
        body: queryArg.address,
      }),
    }),
    updateSubjectAddress: build.mutation<
      UpdateSubjectAddressApiResponse,
      UpdateSubjectAddressApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/addresses/${queryArg.addressId}`,
        method: "PUT",
        body: queryArg.address,
      }),
    }),
    deleteSubjectAddress: build.mutation<
      DeleteSubjectAddressApiResponse,
      DeleteSubjectAddressApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/addresses/${queryArg.addressId}`,
        method: "DELETE",
      }),
    }),
    getPlainSubjectContacts: build.query<
      GetPlainSubjectContactsApiResponse,
      GetPlainSubjectContactsApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/plain-contacts`,
      }),
    }),
    updatePlainSubjectContacts: build.mutation<
      UpdatePlainSubjectContactsApiResponse,
      UpdatePlainSubjectContactsApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/plain-contacts`,
        method: "PUT",
        body: queryArg.contacts,
      }),
    }),
    updateSubjectPersonalData: build.mutation<
      UpdateSubjectPersonalDataApiResponse,
      UpdateSubjectPersonalDataApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/personal-data`,
        method: "PUT",
        body: queryArg.personalData,
      }),
    }),
    createSubjectContact: build.mutation<
      CreateSubjectContactApiResponse,
      CreateSubjectContactApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/contacts`,
        method: "POST",
        body: queryArg.contact,
      }),
    }),
    updateSubjectContact: build.mutation<
      UpdateSubjectContactApiResponse,
      UpdateSubjectContactApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/contacts/${queryArg.contactId}`,
        method: "PUT",
        body: queryArg.contact,
      }),
    }),
    deleteSubjectContact: build.mutation<
      DeleteSubjectContactApiResponse,
      DeleteSubjectContactApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/contacts/${queryArg.contactId}`,
        method: "DELETE",
      }),
    }),
    createSubjectDocument: build.mutation<
      CreateSubjectDocumentApiResponse,
      CreateSubjectDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/documents`,
        method: "POST",
        body: queryArg.subjectDocument,
      }),
    }),
    updateSubjectDocument: build.mutation<
      UpdateSubjectDocumentApiResponse,
      UpdateSubjectDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/documents/${queryArg.documentId}`,
        method: "PUT",
        body: queryArg.subjectDocument,
      }),
    }),
    deleteSubjectDocument: build.mutation<
      DeleteSubjectDocumentApiResponse,
      DeleteSubjectDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/documents/${queryArg.documentId}`,
        method: "DELETE",
      }),
    }),
    createSubjectPaymentMethod: build.mutation<
      CreateSubjectPaymentMethodApiResponse,
      CreateSubjectPaymentMethodApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/payment-methods`,
        method: "POST",
        body: queryArg.paymentMethod,
      }),
    }),
    updateSubjectPaymentMethod: build.mutation<
      UpdateSubjectPaymentMethodApiResponse,
      UpdateSubjectPaymentMethodApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/payment-methods/${queryArg.paymentMethodId}`,
        method: "PUT",
        body: queryArg.paymentMethod,
      }),
    }),
    deleteSubjectPaymentMethod: build.mutation<
      DeleteSubjectPaymentMethodApiResponse,
      DeleteSubjectPaymentMethodApiArg
    >({
      query: (queryArg) => ({
        url: `/subjects/${queryArg.subjectId}/payment-methods/${queryArg.paymentMethodId}`,
        method: "DELETE",
      }),
    }),
    getSubjectHistory: build.query<
      GetSubjectHistoryApiResponse,
      GetSubjectHistoryApiArg
    >({
      query: (queryArg) => ({ url: `/subjects/${queryArg.subjectId}/history` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as apiSubjects };
export type SearchSubjectsApiResponse =
  /** status 200 a searched claims list */ SearchedSubjectsList;
export type SearchSubjectsApiArg = {
  /** result page number */
  pageNum: number;
  /** result page item list */
  pageLen: number;
  /** identifie the scenario to get items list from the correct source */
  scenario: string;
  /** the active role selected by the user */
  activeRole: string;
  searchSubjectsParams: SearchSubjectsParams;
};
export type GetSubjectApiResponse =
  /** status 200 A JSON representing the subject data */ ReadOnlySubject;
export type GetSubjectApiArg = {
  /** Numeric Id of the resource */
  id: number;
  referenceDate?: string;
};
export type DeleteSubjectApiResponse = /** status 200 The item is deleted */ {
  id?: number;
  message?: string;
};
export type DeleteSubjectApiArg = {
  /** Numeric Id of the resource */
  id: number;
};
export type InsertSubjectApiResponse =
  /** status 200 A JSON representing the subject data */ Subject;
export type InsertSubjectApiArg = {
  /** New subject data */
  subject: Subject;
};
export type CreateSubjectAddressApiResponse =
  /** status 200 subject's address list */ Address[];
export type CreateSubjectAddressApiArg = {
  subjectId: number;
  address: Address;
};
export type UpdateSubjectAddressApiResponse =
  /** status 200 subject's address list */ Address[];
export type UpdateSubjectAddressApiArg = {
  subjectId: number;
  addressId: number;
  address: Address;
};
export type DeleteSubjectAddressApiResponse =
  /** status 200 subject's address list */ Address[];
export type DeleteSubjectAddressApiArg = {
  subjectId: number;
  addressId: number;
};
export type GetPlainSubjectContactsApiResponse =
  /** status 200 A JSON representing the subject data */ Contacts;
export type GetPlainSubjectContactsApiArg = {
  subjectId: number;
};
export type UpdatePlainSubjectContactsApiResponse =
  /** status 200 subject's contacts */ Contacts;
export type UpdatePlainSubjectContactsApiArg = {
  subjectId: number;
  contacts: Contacts;
};
export type UpdateSubjectPersonalDataApiResponse =
  /** status 200 A JSON representing the subject data */ PersonalData;
export type UpdateSubjectPersonalDataApiArg = {
  subjectId: number;
  personalData: PersonalData;
};
export type CreateSubjectContactApiResponse =
  /** status 200 subject's contacts list */ Contact[];
export type CreateSubjectContactApiArg = {
  subjectId: number;
  contact: Contact;
};
export type UpdateSubjectContactApiResponse =
  /** status 200 subject's contacts list */ Contact[];
export type UpdateSubjectContactApiArg = {
  subjectId: number;
  contactId: number;
  contact: Contact;
};
export type DeleteSubjectContactApiResponse =
  /** status 200 subject's address list */ Contact[];
export type DeleteSubjectContactApiArg = {
  subjectId: number;
  contactId: number;
};
export type CreateSubjectDocumentApiResponse =
  /** status 200 subject's documents list */ SubjectDocument[];
export type CreateSubjectDocumentApiArg = {
  subjectId: number;
  subjectDocument: SubjectDocument;
};
export type UpdateSubjectDocumentApiResponse =
  /** status 200 subject's documents list */ SubjectDocument[];
export type UpdateSubjectDocumentApiArg = {
  subjectId: number;
  documentId: number;
  subjectDocument: SubjectDocument;
};
export type DeleteSubjectDocumentApiResponse =
  /** status 200 subject's documents list */ SubjectDocument[];
export type DeleteSubjectDocumentApiArg = {
  subjectId: number;
  documentId: number;
};
export type CreateSubjectPaymentMethodApiResponse =
  /** status 200 subject's payment methods list */ PaymentMethod[];
export type CreateSubjectPaymentMethodApiArg = {
  subjectId: number;
  paymentMethod: PaymentMethod;
};
export type UpdateSubjectPaymentMethodApiResponse =
  /** status 200 subject's payment-methods list */ PaymentMethod[];
export type UpdateSubjectPaymentMethodApiArg = {
  subjectId: number;
  paymentMethodId: number;
  paymentMethod: PaymentMethod;
};
export type DeleteSubjectPaymentMethodApiResponse =
  /** status 200 subject's payment-methods list */ PaymentMethod[];
export type DeleteSubjectPaymentMethodApiArg = {
  subjectId: number;
  paymentMethodId: number;
};
export type GetSubjectHistoryApiResponse =
  /** status 200 a JSON describing an array of history logs */
    | SubjectHistory[]
    | /** status 204 The request was correct but the item does not exists */ {
        message?: string;
      };
export type GetSubjectHistoryApiArg = {
  subjectId: number;
};
export type SearchedSubjectsItem = {
  id?: number;
  name?: string;
  fiscalCode?: string;
  pIva?: string;
  subjectType?: string;
  preferredPhone?: string;
  preferredEmail?: string;
  legalEmail?: string;
};
export type SearchedSubjectsList = {
  totalCount?: number;
  currentPageNum?: number;
  totalPageNum?: number;
  pageLen?: number;
  items?: SearchedSubjectsItem[];
};
export type SearchSubjectsParams = {
  tenantId?: number;
  name?: string;
  taxId?: string;
  subjectType?: string;
};
export type NaturalSubject = {
  name?: string;
  lastname?: string;
  gender?: string;
  fiscalCode?: string;
  dateOfBirth?: string;
  cityOfBirth?: string;
  provinceOfBirth?: string;
  countryOfBirth?: string;
};
export type JuridicalSubject = {
  businessName?: string;
  pIva?: string;
};
export type PersonalData = {
  subjectType?: string;
  naturalSubject?: NaturalSubject;
  juridicalSubject?: JuridicalSubject;
};
export type Contacts = {
  phone?: string;
  phoneOther?: string;
  email?: string;
  emailOther?: string;
  legalMail?: string;
};
export type Address = {
  id?: number;
  type?: string;
  street?: string;
  civic?: string;
  postalCode?: string;
  city?: string;
  province?: string;
  country?: string;
  latitude?: number;
  longitude?: number;
  preferred?: boolean;
  isDeleted?: boolean;
  isIncorrect?: boolean;
};
export type PaymentMethod = {
  id?: number;
  type?: string;
  holderName?: string;
  iban?: string | null;
  bicSwift?: string | null;
  addressSendCheck?: Address | null;
  preferred?: boolean;
};
export type Subject = {
  id?: number;
  tenantId?: number;
  personalData?: PersonalData;
  contacts?: Contacts;
  addresses?: Address[];
  paymentMethods?: PaymentMethod[];
};
export type ReadOnlySubject = Subject;
export type Schema = {
  errorCode?: string;
  errorMessage?: string;
};
export type Contact = {
  id?: number;
  type?: string;
  value?: string;
  description?: string;
  useCase?: string;
  preferred?: boolean;
  isDeleted?: boolean;
};
export type SubjectDocument = {
  id?: number;
  documentCode?: string;
  type?: string;
  number?: string;
  issuingDate?: string;
  expirationDate?: string;
  issuingInstitution?: string;
};
export type ModifyDetail = {
  key?: string;
  value?: string;
};
export type SubjectHistory = {
  id?: number;
  modifyType?: string;
  modifyDescription?: string;
  isFrontend?: boolean;
  modifyUser?: string;
  modifyTimestamp?: string;
  modifyDetailsJson?: ModifyDetail[];
};
export const {
  useSearchSubjectsMutation,
  useGetSubjectQuery,
  useLazyGetSubjectQuery,
  useDeleteSubjectMutation,
  useInsertSubjectMutation,
  useCreateSubjectAddressMutation,
  useUpdateSubjectAddressMutation,
  useDeleteSubjectAddressMutation,
  useGetPlainSubjectContactsQuery,
  useLazyGetPlainSubjectContactsQuery,
  useUpdatePlainSubjectContactsMutation,
  useUpdateSubjectPersonalDataMutation,
  useCreateSubjectContactMutation,
  useUpdateSubjectContactMutation,
  useDeleteSubjectContactMutation,
  useCreateSubjectDocumentMutation,
  useUpdateSubjectDocumentMutation,
  useDeleteSubjectDocumentMutation,
  useCreateSubjectPaymentMethodMutation,
  useUpdateSubjectPaymentMethodMutation,
  useDeleteSubjectPaymentMethodMutation,
  useGetSubjectHistoryQuery,
  useLazyGetSubjectHistoryQuery,
} = injectedRtkApi;
